import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  .dataReportSection {
    width: 100%;
    background: #f5f5fd;
    height: calc(100% - 120px);
  }
  .configSection {
    width: ${(props) => (props.isFullScreen ? '0%' : '50%')};
    transition: all 0.2s ease;
    background: white;
    border-radius: 8px;
    margin:${(props) => (props.isFullScreen ? '0px' : '15px')}; 15px;
    margin-right: 0px;
    height: calc(100% - 30px);
    .entitiySelector {
      display: ${(props) => (props.isFullScreen ? 'none' : 'block')};
    }
    .configuration {
      height: calc(100% - 50px);
      overflow-y: scroll;
    }
    .grpby {
      width: 95%;
    }
  }
  .dataSection {
    width: ${(props) => (props.isFullScreen ? '100%' : '50%')};
    background: white;
    border-radius: 8px;
    margin: 15px;
    margin-left: 0px;
    overflow: scroll;
  }
  .minimizer {
    position: relative;
    cursor: pointer;
    .minimizeBtn {
      top: 30px;
      left: ${(props) => (props.isFullScreen ? '-7px' : '-30px;')};
      position: absolute;
      padding: 5px;
      border-radius: 50%;
      background: white;
      border: 2px solid #efefef;
    }
  }
  .modalReportTable{
    .noDataCard{
      display: block;
      position: sticky;
      margin: 0;
      left: 30%;
    }
  }
`;

export { Wrapper };
